import { EntityConstants } from '../../helpers/general.helper';
 
export const triageConstants: EntityConstants = {
	apiEndpoint: '/api/triage',
	navigateToParent: '/med/triage',
	entityLabel: 'Triage',
	entityLabelGender: 'M',
}
 
export interface Triage {
	id: number;
	nombre: string;
	especialidades: string;
	especialidadesMap?: {
		id: number,
		nombre: string,
	}[]
	activo: boolean;
}
 
